import { keyBy } from 'lodash';
/**
 * Return an array of `_id`, `id` fields
 *
 * @deprecated Remove after post.categoryIds will not contain legacy ids
 */
export const getMixedIds = (collection) => Object.keys(getMixedIdsMap(collection));
/**
 * @deprecated Remove after post.categoryIds will not contain legacy ids
 */
export const getMixedIdsMap = (collection) => {
    const mixedIdsMap = {
        ...keyBy(collection, '_id'),
        ...keyBy(collection, 'id'),
    };
    delete mixedIdsMap.undefined;
    delete mixedIdsMap.null;
    return mixedIdsMap;
};
//# sourceMappingURL=mixed-ids.js.map